import React, {useCallback, useContext, useEffect, useState} from 'react';
import _ from 'lodash';
import {WizardPage, wizardProps} from 'gw-portals-wizard-react';
import {useDependencies} from 'gw-portals-dependency-react';
import {useAuthentication} from 'gw-digital-auth-react';
import {useValidation} from 'gw-portals-validation-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import {messages, PolicyChange} from 'gw-capability-policychange-common-react';
import {IntlContext, TranslatorContext} from '@jutro/locale';
import {ViewModelForm} from 'gw-portals-viewmodel-react';
import wizardConfig from '../../config/ba-policychange-wizard-config.json5';
import './PolicyChangePage.messages';
import styles from '../../BAPolicyChange.module.scss';
import metadata from './PolicyChangePage.metadata.json5';
// eslint-disable-next-line import/order
import { DateUtil } from 'gw-portals-util-js';
import PortalUtil from '../../../../utils/PortalUtil';
import {ModalNextProvider} from '@jutro/components';
import {messages as commonMessages} from 'gw-platform-translations';


function BAPolicyChange(props) {
    const { steps } = wizardConfig;
    const { authHeader } = useAuthentication();
    const {
        updateWizardData, changeNextSteps, currentStepIndex, wizardData, policyStatus, createUWActivity, updateCreateUWActivity, jumpToStep
    } = props;
    const translator = useContext(TranslatorContext);
    const { submissionVM, selectedPages, acceptBackDatedPolicy, loadingFirstTime } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const { isComponentValid, registerComponentValidation } = useValidation('BAPolicyChange');
    const [isNoPriorPolicy, setIsNoPriorPolicy] = useState();
    const [isScheduledPolicy, setIsScheduledPolicy] = useState();
    const {dateUtil} = PortalUtil;
    const [minEffectiveDate, setMinEffectiveDate] = useState(false);
    const intl = useContext(IntlContext);
    const [prevSelectedOptions, updatePrevSelectedOptions] = useState([]);

    useEffect(()=>{
        const status = _.get(submissionVM,'baseData.status.value')
        setIsNoPriorPolicy(acceptBackDatedPolicy);
        if(!minEffectiveDate){
            const minimumEffectiveDate = _.get(submissionVM, 'baseData.minimumEffectiveDate.value')
            setMinEffectiveDate(minimumEffectiveDate);
            /*
            * TMI calculation for min date is the Policy Effective date or Today's date minus 30, whichever greater - so if the Policy Effective date
            * is  Jan  1st, 2021, then the broker can only choose the date from April 5th, 2021 (Today's date minus 30)
            *
            *const minDate = new Date();
            *const newMinEffectiveDate = dateUtil.addDaysToLocalDate(dateUtil.toLocalDate(minDate), - 15)
            *_.set(submissionVM, 'baseData.minimumEffectiveDate.value', newMinEffectiveDate);
            */
            updateWizardData(wizardData);
        }
    }, [submissionVM, setMinEffectiveDate, updateWizardData, wizardData]);

    const handleChange = useCallback(
        (options) => {    
            // if(options.includes('other') && !prevSelectedOptions.includes('other')){
            //     submissionVM.description.value = '';
            // }  
            updatePrevSelectedOptions(options);      
            _.forEach(selectedPages, (value, key) => {                
                _.set(wizardData, `selectedPages.${key}`, options.includes(key));
            });
            updateWizardData(wizardData);
        },
        [updateWizardData, wizardData, selectedPages, prevSelectedOptions, updatePrevSelectedOptions]
    );

    const onNext = useCallback(async () => {
        const stepMapping = {
            address: 'Amend Address',
            limit: 'Amend Coverages',
            coverages: 'Amend Coverages',
            insured: 'Amend Address',            
            lienHolder:'Amend Vehicle(s)',
            vehicles: 'Amend Vehicle(s)',
            drivers: 'Amend Driver(s)',
            driverAssignment: 'Amend Vehicle(s)',
            garagedAddress: 'Amend Vehicle(s)'
        }


        let description = submissionVM.description.value;
        if(!selectedPages.other) {
            description = _.uniq(Object.keys(selectedPages).filter((k) => { return selectedPages[k]; }).map((m) => { return stepMapping[m]})).join(', ');
        }

        const response = await EndorsementService.checkEffectiveDateIsValid(
            [submissionVM.policyNumber.value, submissionVM.baseData.effectiveDate.value],
            authHeader
        );
        if (response) {
            const effectiveDateResposne = await EndorsementService.loadEndorsementWithEffectiveDate(
                [submissionVM.policyNumber.value, submissionVM.baseData.effectiveDate.value],
                authHeader
            );
            submissionVM.value = new PolicyChange(effectiveDateResposne);
            
            submissionVM.description.value = description;
            
            submissionVM.value.beforeSave();
            const policyChangeResponse = await EndorsementService.saveEndorsement(
                [submissionVM.value],
                authHeader
            );
            submissionVM.value = new PolicyChange(policyChangeResponse);
        }
        

        if(!selectedPages.other) {
            const newSteps = steps.slice(currentStepIndex + 1, steps.length);
            if (!selectedPages.address && !selectedPages.insured) {
                newSteps.splice(
                    _.findIndex(newSteps, ({ path }) => path === '/address'),
                    1
                );
            }
            if (!selectedPages.drivers) {
                newSteps.splice(
                    _.findIndex(newSteps, ({ path }) => path === '/driver'),
                    1
                );
            }
            if (!selectedPages.vehicles && !selectedPages.lienHolder && !selectedPages.garagedAddress) {
                newSteps.splice(
                    _.findIndex(newSteps, ({ path }) => path === '/vehicles'),
                    1
                );
            }
            if (!selectedPages.driverAssignment && !(selectedPages.drivers || selectedPages.vehicles)) {
                newSteps.splice(
                    _.findIndex(newSteps, ({ path }) => path === '/driverAssignment'),
                    1
                );
            }
            if (!selectedPages.driverAssignment && !(selectedPages.drivers || selectedPages.vehicles)) {
                newSteps.splice(
                    _.findIndex(newSteps, ({ path }) => path === '/riskAnalysis'),
                    1
                );
            }
            changeNextSteps(newSteps);
        }
       
        return wizardData;
    }, [
        submissionVM,
        authHeader,
        steps,
        selectedPages,
        EndorsementService,
        changeNextSteps,
        wizardData,
        currentStepIndex
    ]);

    const getCheckBoxValue = useCallback(() => {
        const result = [];
        _.forEach(selectedPages, (value, key) => {
            if (value) {
                result.push(key);
            }
        });
        return result;
    }, [selectedPages]);

    const handleEffectiveDateChange = (value) => {
        _.set(submissionVM,'baseData.effectiveDate.value',value)
        const endDate = dateUtil.toDate(_.get(submissionVM, 'baseData.periodEndDate.value'));
    const startDate = dateUtil.toDate(_.get(submissionVM,'baseData.effectiveDate.value'));
        const renewalDateObj = _.get(submissionVM, 'baseData.renewalPeriodEndDate.value')
        if(renewalDateObj){
            const renewalEndDate = dateUtil.toDate(renewalDateObj);
            if(startDate > endDate && startDate < renewalEndDate) {
                ModalNextProvider.showAlert({
                    title: 'Review Effective Date Changes',
                    message: 'Please confirm the policy changes are for Renewal policy',
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).then(() => {
                        updateWizardData(wizardData);
                    }, _.noop);
            } else {
                updateWizardData(wizardData);
            }
        } else {
            updateWizardData(wizardData);
        }
    };
    const effectiveDateValue = _.get(submissionVM, 'baseData.effectiveDate.value');
    const startDate = (effectiveDateValue !== undefined && effectiveDateValue !== "") ? dateUtil.toDate(_.get(submissionVM, 'baseData.effectiveDate.value')) : '';

    const minEffDate = dateUtil.toDate(_.get(submissionVM, 'baseData.minimumEffectiveDate.value'));
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = _.get(submissionVM, 'baseData.maximumEffectiveDate.value');
    const renewalEndDate = _.get(submissionVM, 'baseData.renewalPeriodEndDate.value');
    let maxDate = dateUtil.toDate(renewalEndDate || endDate);
    if (maxDate) {
        maxDate = DateUtil.dateDaysAgo(maxDate, 1)
    }
    const minimumEffectiveDate = startDate !== '' ? dateUtil.addDaysToLocalDate(dateUtil.toLocalDate(startDate), -30) : '';

    const getEffectiveDateErrorMessage = () => {
        if (minEffDate > startDate) {
            return [translator(messages.minimumDateErrorMsg, { minEffDate: intl.formatDate(minEffDate, { year: 'numeric', month: 'short', day: 'numeric' }) })];
        }
        if (startDate > maxDate) {
            return [translator(messages.maxDateErrorMsg, { maxDate: intl.formatDate(maxDate, { year: 'numeric', month: 'short', day: 'numeric' }) })];
        }
        return [];
    };

    const editableStatuses = ['Draft', 'Bound', 'Quoted'];

    const transactionStatus = submissionVM?.status?.value?.code;
    const isEffectiveDateReadOnly = !editableStatuses.includes(transactionStatus);


    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: 'left',
            showRequired: true
        },
        baPolicyChangeEffectiveDate: {
            readOnly: isEffectiveDateReadOnly,
            minDate: minEffDate,
            maxDate: maxDate,
            showErrors: false,
            validationMessages: getEffectiveDateErrorMessage(),
            onValueChange: handleEffectiveDateChange
        },
        typeSelector: {
            value: getCheckBoxValue(),
            onValueChange: handleChange
        },
        backDatedEndorsementSection:{
            visible: today > startDate,
        },
        noPriorClaimsOccurred:{
            required: true,
            showRequired: true,
            value: isNoPriorPolicy,
            onValueChange: (value) => {
                _.set(wizardData, 'acceptBackDatedPolicy', value)
                setIsNoPriorPolicy(value);
            }
        },
        /*scheduledEndorsementSection:{
            visible: policyStatus === 'Scheduled'
        },*/
        scheduledPolicyAccept:{
            required: true,
            showRequired: true,
            value: createUWActivity,
            onValueChange: (value) => {
                updateCreateUWActivity(value);
            }
        },
        description:{
            visible: _.get(wizardData, 'selectedPages')['other'],
            onValueChange: (value, path) => {
                _.set(wizardData, `submissionVM.description.value`, value);
                updateWizardData(wizardData);
            },
            labelPosition: 'left',
            required: !!_.get(wizardData, 'selectedPages')['other'],
            showRequired: true
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    const checkSelectedPages = useCallback(() => {
        return !(selectedPages.address === false
            && selectedPages.vehicles === false
            && selectedPages.drivers === false
            && selectedPages.driverAssignment === false
            && selectedPages.coverages === false
            && selectedPages.lienHolder === false
            && selectedPages.insured === false
            && selectedPages.limit === false
            && selectedPages.garagedAddress === false
            && selectedPages.other === false)

    }, [selectedPages]);

    useEffect(() => {
        if(submissionVM.value.status === 'Quoted' && submissionVM.value.description === 'Renewal Policy Change' && loadingFirstTime){
            submissionVM.value.description = '';
            _.set(wizardData, 'loadingFirstTime', false);
            updateWizardData(wizardData);
            navigateToCoverages();
        } 
        else if(submissionVM.value.status === 'Quoted' && loadingFirstTime){
            _.set(wizardData, 'loadingFirstTime', false);
            updateWizardData(wizardData);
            navigateToCoverages();
        } else {
        registerComponentValidation(checkSelectedPages);
        }
    }, [checkSelectedPages, registerComponentValidation]);

    const navigateToCoverages = useCallback(() => {
        const indexOfGeneralCoverages = _.findIndex(
            steps,
            ({ path }) => path === '/quote'
        );
        jumpToStep(indexOfGeneralCoverages);
    }, [jumpToStep, steps]);

    return (
        <WizardPage
            onNext={onNext}
            disableNext={!isComponentValid || (today > startDate && !isNoPriorPolicy) || (minEffDate > startDate || startDate > maxDate)}
            showPrevious={false}
            cancelLabel={(appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

BAPolicyChange.propTypes = wizardProps;
export default BAPolicyChange;
